/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SetupAwsPrivateLinkRequest {
  /**
  * AWS RAM Resource Share ARN that contains the VPC Lattice Resource Configuration.
  */
  'ramResourceShareArn': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "ramResourceShareArn",
      "baseName": "ramResourceShareArn",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SetupAwsPrivateLinkRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

